/**
 * Cuantas filas pide el detalle de la lista de precios.
 *
 * Regla: solo "Todas" sin busqueda se pagina (10 por pagina, o lo que se elija
 * en "Mostrar"). Con una busqueda, o con los filtros "Precio editado",
 * "Precio base" y "Precio ofertado", se traen TODAS las coincidencias en una
 * sola pagina: asi se ven y se seleccionan completas para la edicion masiva.
 */

// Tope de seguridad para "todas": muy por encima del catalogo actual.
export const SIN_LIMITE = 5000

export function isPaginated(filter, search) {
  const hayBusqueda = Boolean(search && String(search).trim() !== '')
  return (filter || 'todas') === 'todas' && !hayBusqueda
}

export function effectivePerPage(filter, search, perPage) {
  if (!isPaginated(filter, search)) return SIN_LIMITE

  return perPage === 'Todos' ? SIN_LIMITE : perPage
}
